import { GET_RTT_DASH_LOG, GET_RTT_ERRORS_LAST_CALLS} from './actionTypes';
import { getActionStatusName } from '@/store/helpers';
import { cloneDeep } from 'lodash';

export const getRttDashLogStatus = state => state.status[getActionStatusName(GET_RTT_DASH_LOG)] || {};
export const getRttLastErrorsStatus = state => state.status[getActionStatusName(GET_RTT_ERRORS_LAST_CALLS)] || {};
export const runRequestSettingsRequest = state => state.status[getActionStatusName('runRequestSettingsRequest')] || {};

export const requestSettings = state => (campaignId, affiliateId) => {
  return GetProperty(state, campaignId, affiliateId, 'requestSettings', {
    url: '',
    method: 'get',
    body: '',
    headers: {},
  });
};

export const requestSettingsModified = state => (campaignId, affiliateId) => {
  return GetProperty(state, campaignId, affiliateId, 'requestSettingsModified', false);
};

export const GetProperty = (state, campaignId, affiliateId, property, valueIfNotFound) => {
  if (!state.campaigns || !campaignId || !state.campaigns[campaignId]) {
    return valueIfNotFound;
  } else if (affiliateId) {
    if (state.campaigns[campaignId].publishers && state.campaigns[campaignId].publishers[affiliateId]) {
      const pubProperty = state.campaigns[campaignId].publishers[affiliateId][property];
      return (pubProperty != null && typeof(pubProperty) != 'undefined') ? state.campaigns[campaignId].publishers[affiliateId][property] : cloneDeep(state.campaigns[campaignId][property]);
    }
    return valueIfNotFound;
  } else if (state.campaigns[campaignId][property] != null && typeof(state.campaigns[campaignId][property]) != 'undefined') {
    return cloneDeep(state.campaigns[campaignId][property]);
  } else {
    return valueIfNotFound;
  }
};

export const requestSettingsRequestStatus = state => state.status[getActionStatusName('requestSettingsRequest')] || {};
export const confirmationSettingsRequestStatus = state => state.status[getActionStatusName('confirmationSettingsRequest')] || {};
